import { FONT_SIZE_MAP } from "components/common/Typography/styled";
import { newColors } from "constants/newColors";
import styled from "styled-components";

export const StyledLink = styled.a<{
  fontSize?: "small" | "medium" | "large";
}>`
  word-break: break-word;
  white-space: pre-line;

  :visited {
    color: ${newColors.defaultLink};
  }

  font-size: ${({ fontSize }) =>
    fontSize ? FONT_SIZE_MAP[fontSize] : FONT_SIZE_MAP["medium"]};
`;
